export default __webpack_public_path__ + "static/media/logo-blue.e05833a5.svg";